export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TIMEOUT = process.env.REACT_APP_API_TIMEOUT;
export const SESSION_TTL = process.env.REACT_APP_SESSION_TTL;
export const DO_NOT_LOGIN = false;
export const SIDER_WIDTH = 320;
export const AVATAR_SIZE = 40;
export const MODAL_WIDTH = 640;
export const DEFAULT_PAGINATION_SIZE = 20;
export const DEFAULT_SORTER_ORDER = "asc";
export const STATUS = ["DELETED", "DISABLED", "ENABLED", "IN_DRAFT", "IN_MAINTENANCE"];
export const STATUS_DELETED = "DELETED";
export const STATUS_DISABLED = "DISABLED";
export const STATUS_ENABLED = "ENABLED";
export const STATUS_IN_DRAFT = "IN_DRAFT";
export const STATUS_IN_MAINTENANCE = "IN_MAINTENANCE";
export const SOURCE = ["INTEGRATOR_SETUP", "INTEGRATOR_GAME", "INTEGRATOR_ENVIRONMENT"];
export const DEVICES = ["MOBILE", "DESKTOP", "ALL"];
export const INTEGRATOR_NAME_LENGTH = 50;
export const INTEGRATOR_NAME_GAME_CATEGORY_LENGTH = 150;
export const INTEGRATOR_GAME_NAME_LENGTH = 200;
export const DEFAULT_LOCALE = "en";
export const DEFAULT_FALLBACK_LANG_ID = 44;
export const CREDENTIAL_TYPE_TEST = "TEST";
export const CREDENTIAL_TYPE_PROD = "PROD";
export const LOCAL_STORAGE_KEY_LAUNCH = "@/tools/launch/4";
export const LOCAL_STORAGE_KEY_FREE_SPINS = "@/freespins/3";
export const LOCAL_STORAGE_KEY_LOCALE = "@/app/locale";
export const SORTER_STEPS_ORDER = ["asc", "desc", null];
export const SCENARIO_TYPES = [
  "INVALID_CURRENCY",
  "INVALID_GAME",
  "INVALID_PLAYER",
  "INVALID_SESSION_ID",
  "INVALID_SIGNATURE",
  "DUPLICATED",
  "OTHER_ERROR",
  "HAPPY_PATH",
];

export const STRING = "STRING";
export const LIST = "LIST";
export const MULTI_LIST = "MULTI_LIST";
export const CURRENCIES_LIST = "CURRENCIES_LIST";
export const CURRENCIES_MULTI_LIST = "CURRENCIES_MULTI_LIST";
export const GAMES_EDITOR_VIEW_LOCAL_STORAGE_KEY = "GAMES_EDITOR_VIEW";
